import React from 'react'
import { BlockWrapper, defineBlock, useEditor } from '@smartfire/js-block-engine'
import { useMediaQuery } from '../../hooks'
import style from './style.module.scss'

const Partners: React.FC<{
    partnersLine1: Record<string, string>[]
    partnersLine2: Record<string, string>[]
    partnersLine3: Record<string, string>[]
    display_partnersLine1: string
    display_partnersLine2: string
    display_partnersLine3: string
}> = ({ display_partnersLine1, partnersLine1, display_partnersLine2, partnersLine2, display_partnersLine3, partnersLine3 }) => {
    const { isEditing } = useEditor()
    const isMobile = useMediaQuery(`(max-width: ${style.mobileBreakpoint})`)

    const Wrapper = isEditing ? 'div' : 'a'

    const displayLine1 = (isMobile && (display_partnersLine1 === 'mobile' || display_partnersLine1 === 'all')) || (!isMobile && (display_partnersLine1 === 'desktop' || display_partnersLine1 === 'all'))
    const displayLine2 = (isMobile && (display_partnersLine2 === 'mobile' || display_partnersLine2 === 'all')) || (!isMobile && (display_partnersLine2 === 'desktop' || display_partnersLine2 === 'all'))
    const displayLine3 = (isMobile && (display_partnersLine3 === 'mobile' || display_partnersLine3 === 'all')) || (!isMobile && (display_partnersLine3 === 'desktop' || display_partnersLine3 === 'all'))

    const isLine1Visible = partnersLine1 && partnersLine1.length > 0 && displayLine1
    const isLine2Visible = partnersLine2 && partnersLine2.length > 0 && displayLine2
    const isLine3Visible = partnersLine3 && partnersLine3.length > 0 && displayLine3

    return (
        <BlockWrapper.Div className={style.partners}>
            {isEditing ? (
                <p className={style.BOinfo}>Les logos des partenaires apparaîtront ici.</p>
            ) : (
                <>
                    {isLine1Visible && (
                        <div className={style.line1}>
                            {partnersLine1.map((partner) => (
                                <Wrapper
                                    href={partner.link}
                                    className={style.wrapper}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        className={style.partner}
                                        alt="Partner"
                                        src={partner.partner}
                                    />
                                </Wrapper>
                            ))}
                        </div>
                    )}
                    {isLine2Visible && (
                        <div className={style.line2}>
                            {partnersLine2.map((partner) => (
                                <Wrapper
                                    href={partner.link}
                                    className={style.wrapper}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        className={style.partner}
                                        alt="Partner"
                                        src={partner.partner}
                                    />
                                </Wrapper>
                            ))}
                        </div>
                    )}
                    {isLine3Visible && (
                        <div className={style.line3}>
                            {partnersLine3.map((partner) => (
                                <Wrapper
                                    href={partner.link}
                                    className={style.wrapper}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        className={style.partner}
                                        alt="Partner"
                                        src={partner.partner}
                                    />
                                </Wrapper>
                            ))}
                        </div>
                    )}
                </>
            )}
        </BlockWrapper.Div>
    )
}

export default defineBlock({
    Block: Partners,
    setup: {
        title: 'Footer - Partners',
        parent: ['footer'],
    },
})
